import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";

import useStateRef from 'react-usestateref';
import swal from 'sweetalert';
import toast, { Toaster } from 'react-hot-toast';

import apiPath from "../../../config/apipath";
import apiService from "../../../provider/apiService";


const CounterTable = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [counter, setCounter] = useState([]);
  const [department, setDepartment, departmentRef] = useStateRef('');
  const [deptcode, setDeptcode, deptcodeRef] = useStateRef('');
  const [sstatement, setSstatement, sstatementRef] = useStateRef('');
  const [msresults, setMsresults, msresultsRef] = useStateRef([]);

  const [errors, setErrors] = useState({});


  const notify1 = () => toast.success('Successfully Deleted.');
  const notify2 = () => toast.error("Not able to Delete");



  useEffect(() => {
    getCounter();
  }, []);

  async function getCounter() {
    try {
      let results = await apiService.getCounter(apiPath.master.get.getCounter);
      if (results != "-1") {
        setCounter(results.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function insertUpdateCounter() {
    try {
      let postData = {
        "deptname": departmentRef.current,
        "code": Number(deptcodeRef.current),
        "StatementType": String(sstatementRef.current)
      }
      let results = await apiService.insertUpdateCounter(apiPath.master.insertUpdate.insertUpdateCounter, postData);

      if (results != "-1") {

        console.log(results, "result insert");
        getCounter();
        setMsresults(results)
      }
    } catch (e) {
      console.log(e);
    }

  }

  const SubmitCall = () => {
    try {
      const isFormValid = validateForm();
      if (isFormValid) {
        insertUpdateCounter();
        swal({
          title: "Success",
          text: "Successfully Added",
          icon: "success",
          button: "Ok"
        }).then(function () {
          setShow1(false);
          getCounter()
        });
      }

    } catch (e) {
      console.log(e);
    }
  }

  const handleShow1 = (type, code, deptName, statement, show) => {
    setDepartment(deptName);
    setDeptcode(code);
    setSstatement(statement);

    if (statement == 'Delete') {
      insertUpdateCounter();
      if (msresults != '-1') {
        notify1();
      }
      else {
        notify2();
      }
    }

    if (type == 1) { // add
      setSho('Add New');
      setShow('Save');
    } else {//edit
      setSho('Edit');
      setShow('Update');
    }
    setShow1(show);
  }

  const validateForm = () => {
    const newErrors = {};
    if (!department.trim()) {
      newErrors.department = 'Account Name is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>

            <Card.Header className="d-flex justify-content-between">

              <div className="header-title">
                <h4 className="card-title">To Add, Modify Counter details.</h4>
                <Toaster
                  position="bottom-right"
                  reverseOrder={false}
                />
              </div>

              <div>
                <div style={{ display: 'flex', marginLeft: '91px', alignItems: 'center' }}>
                  <div style={{ paddingRight: '10px' }}>
                    <Form.Control type="search" className="form-control mr-sm-2" placeholder="Search" aria-label="Search" />
                  </div>
                  <div >
                    <Button className="text-center btn-primary btn-sm btn-icon mt-lg-0 mt-md-0 mt-3 ">
                      <i className="btn-inner">
                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </i>
                    </Button>
                  </div>
                </div>
              </div>

              <div className="col d-flex justify-content-end">

                <Button className="text-center btn-primary btn-icon mt-lg-0 mt-md-0 mt-3 "
                  onClick={() => { handleShow1(1, "0", "", "Insert", true) }}>
                  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
                  <span>Add Counter</span>
                </Button>

                <Modal show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Counter</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <Form.Group className="mb-3">
                      <Form.Label>Counter <span className="text-danger">*</span></Form.Label>
                      <Form.Control type="text" value={department} id="deptname" placeholder="Enter Counter" onChange={(e) => setDepartment(e.target.value)} isInvalid={!!errors.department} />
                    </Form.Group>

                    <div style={{ "direction": 'rtl' }}>
                      <Button variant="primary" onClick={() => { SubmitCall() }}>{show}
                      </Button>		{' '}
                      <Button variant="danger" onClick={handleClose1}>  Cancel </Button>
                    </div>

                  </Modal.Body>
                </Modal>
              </div>
            </Card.Header>
            <Card.Body>

              <div className="table-responsive border-bottom my-3">
                <Table
                  responsive
                  striped
                  id="datatable"
                  className=""
                  data-toggle="data-table"
                >

                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>DeptName</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {counter.map((item) => (
                      <tr>
                        <td>{item.Code}</td>
                        <td>{item.DeptName}</td>
                        <td>
                          <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit User" to="#"
                            onClick={() => { handleShow1(2, item.Code, item.DeptName, "Update", true) }} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>
                        <td>
                          <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete User" to="#"
                            onClick={() => { handleShow1(0, item.Code, " ", "Delete", false) }}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default CounterTable;
